import { motion } from 'framer-motion'
import React from 'react';

interface IModalProps {
  children: React.JSX.Element
  className?: string
}

export default function InterestModal({ className, children }: IModalProps) {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{
        type: 'spring',
        stiffness: 400,
        damping: 30,
        mass: 1,
        delay: 0,
      }}
      onClick={(e) => e.stopPropagation()}
      className={className}
    >
      {children}
    </motion.div>
  )
}
